<template>
  <Modal :id="'cmp-offer-list'" @cancelled="onCancel">
    <template slot="header">{{$t('all_templates')}}</template>

    <template slot="body">
      <div class="form-group">
        <Dropdown
          :options="subjects"
          :selected="subjects.find((e) => e.value == selectedSubject)"
          :placeholder="$t('subject_string')"
          box
          v-on:selectedChange="(e) => onSubjectSelect(e)"
        ></Dropdown>
      </div>
      <div class="dt-list" v-if="templates">
        <div
          class="dt-list-item"
          v-for="templ of templates"
          :key="templ.template_id"
        >
          <div
            class="dt-list-item--body"
            @click="(e) => onTemplateClick(templ)"
            :title="templ.description"
          >
            <div class="dt-list-item--text">{{ templ.description }}</div>
          </div>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { MHTTPCL } from "../../../../services/http/http-client";
import { SETTINGS_URL } from "../../../../services/common-urls";
import { sendMail } from "../../../../utility";

import { overviewService } from "../../services/booking-details/booking-overview.service";
// import { createBookingFlat } from '../../models/booking-overview.model';

export default {
  components: {
    Modal,
  },
  props: ["booking", "templates"],
  mounted: async function () {
    console.log("THIS ", this.$route.params.calendar_date_id);

    // await overviewService.getCalendarDateJSON(this.$route.params.calendar_date_id)
    //this.offerMailData = await overviewService.getQuestionnairetemplate()
    // this.offerMailData = await overviewService.getQuestionnairetemplate()

    this.selectedSubject = this.subjects?.[0]?.value;
  },
  data: function () {
    return {
      offerMailData: null,
      selectedSubject: null,
    };
  },
  computed: {
    // templates: function() {
    //   return this.offerMailData?.data.templates || [];
    // },
    subjects: function () {
      return this.templates.map((e) => ({
        text: e.subject,
        value: e.template_id,
      }));
    },
    artist_id() {
      return this.$route.query.artist_id || "";
    },
    email() {
      return this.$route.query.email || "";
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onSubjectSelect: function (e) {
      this.selectedSubject = e.value;
    },
    onTemplateClick: async function (template) {
      const { template_id } = template;
      // console.log(template);
      // console.log(createBookingFlat(this.booking, this.artist_id));

      // const templateResult = await MHTTPCL.post(SETTINGS_URL, {
      //   ...createBookingFlat(this.booking, this.artist_id),
      //   template_id,
      //   template_key: "offer_mail_to_artist",
      //   section: "templates",
      //   subject: this.subjects.find(e => e.value == this.selectedSubject)?.text,
      //   action: "render"
      // }).then(res => res.data);
      //console.log("WWWWWWWWWWWW",this.email)
      // sendMail({
      //   subject: templateResult.render_subject,

      //   body: templateResult.render_text,
      //   mails: this.email.split(","),
      //  to:this.email
      // });

      // console.log("RRRRRRRRRRR",this.$route.query.selectedRelation)
      // await overviewService.postLocalDetailsType(this.$route.query.selectedRelation,this.$route.params.calendar_date_id)
      //  window.open(this.$route.query.mailtoLink, '_blank');
      //await overviewService.postLocalDetailsType()
    },
    //MARK: Methods
  },
};

// export const createBookingFlat = (booking, artist_id) => {
//   const artist = booking?.artists?.find((a) => a.artist_id == artist_id) || {};
//   const cdate = booking?.cdate || {};
//   const location = booking?.location || {};
//   const promoter = booking?.promoter || {};
//   console.log("Log: createBookingFlat -> promoter", promoter);

//   const start_date = cdate?.start_date || "";
//   const booking_location_name = location?.booking_location_name || "";
//   const city = location?.city || "";
//   const country = location?.country || "";
//   const first_offer_notes = artist?.first_offer_notes || "";
//   const email_to = artist?.email1 || "";
//   const artist_name = artist?.artist_name || "";
//   const performance_type = artist?.performance_type || "";
//   const event_name = "";
//   const notes_ical = cdate?.notes;
//   const calendar_date_id = cdate?.calendar_date_id;
//   const venue_name = location?.booking_location_name;
//   const venue_address = location?.address1;
//   const venue_city = location?.city;
//   const venue_postalcode = location?.postalcode || "";
//   const venue_country = location?.country || "";
//   const venue_phone = location?.phone1 || "";
//   const venue_email = location?.email || "";
//   const venue_url = location?.url1 || "";
//   const venue_capacity = location?.venue_capacity || "";

//   const promoter_company_name = promoter?.company_name || "";
//   const promoter_representative = promoter?.representative || "";

//   const promoter_first_name = promoter?.first_name || "";
//   const promoter_last_name = promoter?.last_name || "";

//   const promoter_address = promoter?.address || "";
//   const promoter_city = promoter?.city || "";
//   const promoter_postalcode = promoter?.postalcode || "";
//   const promoter_state = promoter?.state || "";
//   const promoter_country = promoter?.country || "";
//   const promoter_phone = promoter?.phone1 || "";
//   const promoter_mobile = promoter?.phone2 || "";
//   const promoter_email = promoter?.email1 || "";
//   const promoter_vat_id = promoter?.vat_id || "";
//   const promoter_url = promoter?.url || "";
//   const promoter_language = promoter?.language || "";

//   return {
//     start_date,
//     booking_location_name,
//     city,
//     country,
//     first_offer_notes,
//     email_to,
//     artist: artist_name,
//     performance_type,
//     event_name,
//     notes_ical,
//     calendar_date_id,
//     venue_name,
//     venue_address,
//     venue_city,
//     venue_postalcode,
//     venue_country,
//     venue_phone,
//     venue_email,
//     venue_url,
//     venue_capacity,

//     promoter_company_name,
//     promoter_representative,
//     promoter_first_name,
//     promoter_last_name,
//     promoter_address,
//     promoter_city,
//     promoter_postalcode,
//     promoter_state,
//     promoter_country,
//     promoter_phone,
//     promoter_mobile,
//     promoter_email,
//     promoter_vat_id,
//     promoter_url,
//     promoter_language,
//   };
// };
</script>

<style lang="scss">
.cmp-offer-list {
  .dt-list {
    margin-top: 10px;
    border: 1px solid var(--sprt-8);
    .dt-list-item--text {
      font-weight: 500;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>
